import TagIcon from "@redotech/redo-icons/tag-01.svg";
import { Tag } from "@redotech/redo-model/tag";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import {
  AdvancedTableFilter,
  ArrayStringTableFilter,
} from "@redotech/redo-web/advanced-filters/advanced-filter";
import { BadgePillThemeToColorMapping } from "@redotech/redo-web/tags/tag-pill";

export const TagFilter = (
  fetcher: (
    { filters }: { filters: AdvancedTableFilter[] },
    signal: AbortSignal,
  ) => Promise<Tag[]>,
): ArrayStringTableFilter<Tag | string> => ({
  type: AdvancedFilterType.ARRAY_TO_STRING,
  itemLabel: "tag",
  operators: [
    ArrayStringFilterOperator.NONE_OF,
    ArrayStringFilterOperator.ALL_OF,
    ArrayStringFilterOperator.ANY_OF,
  ],
  data: {
    name: "tagName",
    type: AdvancedFilterType.ARRAY_TO_STRING,
    value: [],
    operator: ArrayStringFilterOperator.ALL_OF,
  },
  Icon: TagIcon,
  valueFetcher: fetcher,
  itemGenerator: (item: Tag | string) => ({
    id: typeof item === "string" ? item : item.name,
    value: item,
    type: "badge",
    badge: {
      text: typeof item === "string" ? item : item.name,
      color:
        typeof item === "string"
          ? undefined
          : BadgePillThemeToColorMapping[item.pillTheme],
    },
  }),
  stringify: (item: Tag | string) =>
    typeof item === "string" ? item : item.name,
  display: (item: Tag | string) =>
    typeof item === "string" ? item : item.name,
  displayName: "Tag",
});
